import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "38",
  height: "52",
  fill: "none",
  viewBox: "0 0 38 52"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 4C0 .702 3.763-1.179 6.4.8l29.333 21.996c2.134 1.6 2.134 4.8 0 6.4L6.4 51.199C3.763 53.177 0 51.296 0 48z"
    }, null, -1)
  ]))]))
}
export default { render: render }